<template lang="pug">
#startflow(v-loading="loading" element-loading-text="数据处理中...")
  .left(:class="{ showNode: showSteps }")
    .stageTitle
      .name 基本信息
      el-button.floatSteps( type="text",v-if="!showSteps", @click="queryApproveNodes") 查询处理人
        i.el-icon-arrow-right.el-icon--right
    component(ref="businessForm"
      :is="basicForm"
      :flowMessage="flowInfo"
      :prjId="approvalPrjId"
      :flowDefinitionId="flowDefinitionId"
      :formId="formId"
      :uuid="uuid"
      :key="comKey"
      flowModeStatus="approve"
      @hook:mounted="onFlowFormLoad",
      @loadComplete="loadComplete")
    //- 兼容代码组件使用上传的文件，后期建议抛弃
    viewFileEditor(ref="viewFileEditor" :uuid="uuid", :flowKey="flowInfo.flowKey" noDelete v-if="!isLowCode")

    template(v-if="fileList.length>0")
      .uploaderTitle 流程附件
      viewFileList(ref="viewFileList",:uuid="uuid" :files="fileList"  noDelete)
    .check
      el-button(size="small", type="primary", plain, @click="queryFlowImage") 查询流程图
    .flowShowImage(v-if="showType === 'img'")
      el-image(:src="flowImage" :previewSrcList="[flowImage]")
  .right(v-if="nodeList.length>0 && showSteps")
    flowNodesNew(ref="flowNodesNew" :uuid="uuid"  :getBasicData="getBasicData" @closeDialog="closeDialog" @stepsClose="stepsClose")
</template>

<script>
import viewFileList from "@/CommonDP/components/processComponents/flowNewConfig/viewFileList.vue";
import viewFileEditor from "@/CommonDP/components/processComponents/flowNewConfig/viewFileEditor.vue";
import flowNodesNew from "@/CommonDP/components/processComponents/flowNewConfig/flowNodesNew.vue";
import { flowDetailMixins } from "./mixins.js";
export default {
  components: { viewFileList, flowNodesNew, viewFileEditor },
  mixins: [flowDetailMixins],
  props: {
    uuid: { type: String, default: "" }
  },
  data () {
    return {
      loading: false,
      flowMessage: {},
      detailMessage: "",
      basicForm: "",
      showSteps: true,
      approvalPrjId: "",
      showType: "", // user:处理人 ,img:流程图
      comKey: 0,
      nodes: []
    };
  },
  mounted () {
    this.addInit();
  },
  methods: {
    queryApproveNodes() {
      this.showSteps = true;
    },
    stepsClose() {
      this.showSteps = false;
    }
  }
};
</script>

<style lang="scss" scoped>
#startflow{
  width: 100%;
  height: 100%;
  padding: 0 10px;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  // overflow-x: hidden;
  // overflow-y: auto;
  .left{
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0 10px;
    transition: all 0.3s;
    padding-bottom: 25px;
  }
  .right{
    width: 500px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    transition: all 0.3s;
  }
  .stageTitle {
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid #ebefff;
    margin-bottom: 10px;
    color: var(--theme-color);

    .name {
      font-weight: 700;
      font-size: 16px;
      line-height: 40px;
      color: #3873fe;
    }

    span {
      font-size: 14px;
      line-height: 40px;
    }

    .floatSteps {
      margin-left: auto;
    }
  }
}
.uploaderTitle{
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ebefff;
  margin-bottom: 10px;
  font-weight: 700;
  font-size: 16px;
  line-height: 40px;
  color: var(--theme-color);
}
.check {
  margin-top: 5px;
  height: 45px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.flowShowImage{
  width: 100%;
  img{
    width: 100%;
    object-fit: contain;
  }
}
</style>
